<template>
    <div class="second-row__text-input">
        <v-chip class="text-center chip input-chip"
                :style="`width: ${inputWidth}px`">
            <v-text-field
                    autocomplete="off"
                    v-model.number="inputValue"
                    class="text-center input-chip"
                    label="ex: 300"
                    type="number"
                    solo>
            </v-text-field>
        </v-chip>
        <span class="chip-description">{{ description }}</span>
    </div>
</template>

<script>
    export default {
        name: "InputNumber",
        props: ['value', 'description'],
        data: () => ({
            inputValue: null
        }),
        computed: {
            inputWidth: function () {
                if (!this.inputValue) {
                    return 70
                }
                return (`${this.inputValue}`.length + 1) * 6 + 24
            }
        },
        watch: {
            inputValue (val, oldVal ) {
                this.$emit('input', val)
            },
            value (val, oldVal) {
                if (val !== oldVal) {
                    this.inputValue = val
                }
            }
        },
        mounted() {
            if (this.value) {
                this.inputValue = this.value
            }
        },
    }
</script>

<style scoped>

</style>
